module.exports = __webpack_public_path__ + "static/media/sStl.e733c5aa.png";